import React, { ComponentProps } from "react";

export default function CameraOutlineIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      {...props}
    >
      <path
        d="M1.25 4.81361C1.25 3.88102 2.00602 3.125 2.93861 3.125C3.42317 3.125 3.85335 2.81494 4.00658 2.35525L4.0625 2.1875C4.08887 2.10839 4.10205 2.06884 4.11616 2.03375C4.29628 1.5857 4.71837 1.28148 5.20038 1.25229C5.23813 1.25 5.27983 1.25 5.36321 1.25H9.63679C9.72018 1.25 9.76187 1.25 9.79962 1.25229C10.2816 1.28148 10.7037 1.5857 10.8838 2.03375C10.8979 2.06884 10.9111 2.10839 10.9375 2.1875L10.9934 2.35525C11.1466 2.81494 11.5768 3.125 12.0614 3.125C12.994 3.125 13.75 3.88102 13.75 4.81361V10.125C13.75 11.1751 13.75 11.7001 13.5456 12.1012C13.3659 12.454 13.079 12.7409 12.7262 12.9206C12.3251 13.125 11.8001 13.125 10.75 13.125H4.25C3.1999 13.125 2.67485 13.125 2.27377 12.9206C1.92096 12.7409 1.63413 12.454 1.45436 12.1012C1.25 11.7001 1.25 11.1751 1.25 10.125V4.81361Z"
        stroke="#7E43FF"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.25 4.81361C1.25 3.88102 2.00602 3.125 2.93861 3.125C3.42317 3.125 3.85335 2.81494 4.00658 2.35525L4.0625 2.1875C4.08887 2.10839 4.10205 2.06884 4.11616 2.03375C4.29628 1.5857 4.71837 1.28148 5.20038 1.25229C5.23813 1.25 5.27983 1.25 5.36321 1.25H9.63679C9.72018 1.25 9.76187 1.25 9.79962 1.25229C10.2816 1.28148 10.7037 1.5857 10.8838 2.03375C10.8979 2.06884 10.9111 2.10839 10.9375 2.1875L10.9934 2.35525C11.1466 2.81494 11.5768 3.125 12.0614 3.125C12.994 3.125 13.75 3.88102 13.75 4.81361V10.125C13.75 11.1751 13.75 11.7001 13.5456 12.1012C13.3659 12.454 13.079 12.7409 12.7262 12.9206C12.3251 13.125 11.8001 13.125 10.75 13.125H4.25C3.1999 13.125 2.67485 13.125 2.27377 12.9206C1.92096 12.7409 1.63413 12.454 1.45436 12.1012C1.25 11.7001 1.25 11.1751 1.25 10.125V4.81361Z"
        stroke="url(#paint0_linear_468_19198)"
        strokeOpacity="0.16"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 10.3125C9.0533 10.3125 10.3125 9.0533 10.3125 7.5C10.3125 5.9467 9.0533 4.6875 7.5 4.6875C5.9467 4.6875 4.6875 5.9467 4.6875 7.5C4.6875 9.0533 5.9467 10.3125 7.5 10.3125Z"
        stroke="#7E43FF"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 10.3125C9.0533 10.3125 10.3125 9.0533 10.3125 7.5C10.3125 5.9467 9.0533 4.6875 7.5 4.6875C5.9467 4.6875 4.6875 5.9467 4.6875 7.5C4.6875 9.0533 5.9467 10.3125 7.5 10.3125Z"
        stroke="url(#paint1_linear_468_19198)"
        strokeOpacity="0.16"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_468_19198"
          x1="7.5"
          y1="1.25"
          x2="7.5"
          y2="13.125"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_468_19198"
          x1="7.5"
          y1="1.25"
          x2="7.5"
          y2="13.125"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
}
